import { useRoles } from "components/hooks/useRoles";

export function usePreSir() {
  const { applicant, releasedAdmit, postSir, student } = useRoles();
  return !student && !postSir && (applicant || releasedAdmit);
}
